import { Routes } from '@angular/router';

export const MARKETING_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./home-new/home-new.component').then(m => m.HomeNewComponent),
  },
  {
    path: 'pricing',
    loadComponent: () => import('./pricing/pricing.component').then(m => m.PricingComponent),
    title: 'Pricing | Angularize',
  },
  {
    path: 'docs',
    redirectTo: 'docs/what-is-vibe-coding',
  },
  {
    path: 'docs/:pageId',
    loadComponent: () => import('./docs/docs.component').then(m => m.DocsComponent),
    title: 'Documentation | Angularize',
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./contact/contact.component').then(m => m.ContactComponent),
    title: 'Contact Us | Angularize',
  },
  {
    path: 'about-us',
    loadComponent: () => import('./about-us/about-us.component').then(m => m.AboutUsComponent),
    title: 'About Us | Angularize',
  },
  {
    // Linked from how-it-works-dialog ("Learn more" CTA -> /careers).
    // Component lives at features/marketing/careers after the cleanup move.
    path: 'careers',
    loadComponent: () => import('./careers/careers.component').then(m => m.CareersComponent),
    title: 'Careers | Angularize',
  },
  {
    path: 'refund-policy',
    loadComponent: () =>
      import('./refund-policy/refund-policy.component').then(m => m.RefundPolicyComponent),
    title: 'Refund Policy | Angularize',
  },
  {
    path: 'cancellation-policy',
    loadComponent: () =>
      import('./cancellation-policy/cancellation-policy.component').then(
        m => m.CancellationPolicyComponent,
      ),
    title: 'Cancellation Policy | Angularize',
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./terms/terms.component').then(m => m.TermsComponent),
    title: 'Terms and Conditions | Angularize',
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./privacy/privacy.component').then(m => m.PrivacyComponent),
    title: 'Privacy Policy | Angularize',
  },
];